/*
 * Casa Lizette — MSI (Meses Sin Intereses) simulator.
 * Pure client-side display math: price / selected term, formatted as MXN.
 * No network calls, no payment-gateway logic — this is a marketing simulator only.
 * Real MSI is enabled by the card processor configured in Shopify Admin → Settings → Payments.
 */
(function () {
  'use strict';

  var formatter = new Intl.NumberFormat('es-MX', {
    style: 'currency',
    currency: 'MXN',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });

  function formatCents(cents) {
    return formatter.format(cents / 100);
  }

  function initSimulator(el) {
    var priceCents = parseInt(el.getAttribute('data-price'), 10);
    if (!priceCents || isNaN(priceCents)) return;

    var amountEl = el.querySelector('[data-msi-amount]');
    var buttons = el.querySelectorAll('[data-msi-term]');

    function setTerm(months) {
      if (!amountEl || !months) return;
      amountEl.textContent = formatCents(priceCents / months);
      buttons.forEach(function (btn) {
        btn.classList.toggle('is-active', parseInt(btn.getAttribute('data-msi-term'), 10) === months);
      });
    }

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setTerm(parseInt(btn.getAttribute('data-msi-term'), 10));
      });
    });

    // Listen for variant price changes dispatched by product-gallery.js / variant selector.
    document.addEventListener('casa-lizette:variant-change', function (e) {
      if (!e.detail || typeof e.detail.price !== 'number') return;
      priceCents = e.detail.price;
      el.setAttribute('data-price', priceCents);
      var activeBtn = el.querySelector('[data-msi-term].is-active');
      var months = activeBtn ? parseInt(activeBtn.getAttribute('data-msi-term'), 10) : null;
      if (months) setTerm(months);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-msi-simulator]').forEach(initSimulator);
  });
})();
